import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { User } from '@recruitee/account-types';
import { filterBoolean } from '@recruitee/common';

import { UserSelectors } from './user.store';

@Injectable()
export class UsersSelectDataService {
  private readonly users$ = inject(Store).select(UserSelectors.entities()).pipe(filterBoolean);
  public getUsers(): Observable<User[]> {
    return this.users$;
  }
}
